<template>
  <span
    class="CombatPlayersScore"
    :style="{ '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <span class="teamInfor">
      <span
        class="players_row"
        v-text="playerList2PlayerNameString(datas[0].playerInfos)"
      ></span>
      <span class="team_row">
        <span class="teamName" v-text="datas[0].teamName"></span>
        <span class="teamLogo">
          <img :src="datas[0].teamLogo" />
        </span>
      </span>
      <span class="win_icon" v-if="datas[0].winFlag - 0"></span>
    </span>
    <span class="scoreArea">
      <span class="score" v-text="datas[0].teamScore"></span>
      <span class="vs" v-text="'-'"></span>
      <span class="score" v-text="datas[1].teamScore"></span>
    </span>
    <span class="teamInfor">
      <span
        class="players_row"
        v-text="playerList2PlayerNameString(datas[1].playerInfos)"
      ></span>
      <span class="team_row">
        <span class="teamLogo">
          <img :src="datas[1].teamLogo" />
        </span>
        <span class="teamName" v-text="datas[1].teamName"></span>
      </span>
      <span class="win_icon" v-if="datas[1].winFlag - 0"></span>
    </span>
  </span>
</template>

<script>
//  对抗类  球员名字 + 国旗 + 比分  单人 || 双人
export default {
  name: 'CombatPlayersScore',
  props: {
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  methods: {
    playerList2PlayerNameString(list) {
      let playerNameStringArr = []
      if (list && list.length > 0) {
        list.forEach((player) => {
          playerNameStringArr.push(player.playerName ? player.playerName : '')
        })
      }
      return playerNameStringArr.join(' / ')
    },
  },
}
</script>

<style lang="scss" scoped>
.CombatPlayersScore {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  height: auto;
  padding-bottom: calc(1.666vw * var(--mixtmt_mixvw));
  .teamInfor {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: calc(50% - 3.47vw * var(--mixtmt_mixvw));
    height: auto;
    .players_row {
      width: 100%;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor3);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .team_row {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      .teamLogo {
        position: relative;
        width: calc(1.875vw * var(--mixtmt_mixvw));
        height: calc(1.25vw * var(--mixtmt_mixvw));
        overflow: hidden;
        &::before {
          content: '\20';
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: calc(100% - 1.875vw * var(--mixtmt_mixvw));
        padding: 0 calc(0.347vw * var(--mixtmt_mixvw));
        height: calc(1.11vw * var(--mixtmt_mixvw));
        line-height: calc(1.11vw * var(--mixtmt_mixvw));
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
    }
    .win_icon {
      display: block;
      position: absolute;
      bottom: calc(-1.66vw * var(--mixtmt_mixvw));
      z-index: 2;
      width: calc(2.083vw * var(--mixtmt_mixvw));
      height: calc(1.388vw * var(--mixtmt_mixvw));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-image: var(--mixtmt_theme_win_icon);
    }
    &:first-child {
      .players_row {
        text-align: right;
        padding: 0 calc(1.388vw * var(--mixtmt_mixvw))
          calc(0.347vw * var(--mixtmt_mixvw)) 0;
      }
      .team_row {
        justify-content: flex-end;
        padding-right: calc(1.388vw * var(--mixtmt_mixvw));
        .teamName {
          text-align: right;
        }
      }
      .win_icon {
        right: calc(1.388vw * var(--mixtmt_mixvw));
      }
    }
    &:last-child {
      .players_row {
        text-align: left;
        padding: 0 0 calc(0.347vw * var(--mixtmt_mixvw))
          calc(1.388vw * var(--mixtmt_mixvw));
      }
      .team_row {
        justify-content: flex-start;
        padding-left: calc(1.388vw * var(--mixtmt_mixvw));
        .teamName {
          text-align: left;
        }
      }
      .win_icon {
        left: calc(1.388vw * var(--mixtmt_mixvw));
      }
    }
  }
  .scoreArea {
    width: calc(6.94vw * var(--mixtmt_mixvw));
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    background-color: var(--mixtmt_greyColor7);
    border-radius: calc(0.278vw * var(--mixtmt_mixvw));
    height: calc(2.083vw * var(--mixtmt_mixvw));
    margin-top: calc(0.064vw * var(--mixtmt_mixvw));
    .score {
      width: calc(50% - 0.694vw * var(--mixtmt_mixvw));
      text-align: center;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
    .vs {
      width: calc(1.388vw * var(--mixtmt_mixvw));
      text-align: center;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor4);
    }
  }
}
</style>
